import styled from 'styled-components'
import { Button, Card, Autocomplete, Typography } from '@equinor/eds-core-react'

export const BackgroundContainer = styled.div`
    min-height: 100%;
    height: auto;
    width: auto;
    display: flex;
    flex-direction: column;
    padding: 24px;
    gap: 8px;
    background-color: rgb(245, 245, 245);
    box-shadow: none;
    align-items: center;

    @media (max-width: 1024px) {
        flex: 1;
        margin-right: 0;
        padding: 0px;
        gap: 0px;
    }
`

export const HeaderContainer = styled(Card)`
    display: flex;
    width: 100%;
    align-self: center;
    padding-top: 8px;
    padding-bottom: 32px;
    background-color: rgb(245, 245, 245);
    box-shadow: none;

    @media (max-width: 1024px) {
        padding: 16px;
    }
`

export const ContentContainer = styled.div`
    display: flex;
    justify-content: center;
    width: 100%;
    padding: 0 24px;
    gap: 48px;
    align-self: center;

    @media (max-width: 1024px) {
        gap: 24px;
        padding: 0px;
        flex-direction: column;
        align-items: center;
        padding-bottom: 24px;
    }
`

export const AboutContainer = styled(Card)`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 600px;
    padding: 24px;
    gap: 8px;
    align-items: center;
    background-color: rgb(255, 255, 255);
    box-sizing: border-box;

    @media (max-width: 1024px) {
        width: calc(100% - 32px);
        height: auto;
        padding: 16px;
        margin: 0 16px;
    }
`

export const RecentlyAddedSensorsContainer = styled(Card)`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 600px;
    padding: 24px;
    gap: 16px;
    flex-wrap: wrap;
    align-items: stretch;
    background-color: rgb(255, 255, 255);
    box-sizing: border-box;

    @media (max-width: 1024px) {
        width: 100%;
        height: auto;
        align-items: stretch;
        background-color: initial;
        box-shadow: none;
        padding: 0 16px;
    }
`

export const ReadMoreButton = styled(Button)`
    width: 104px;
    height: 48px;
    padding: 0px;
    margin-left: auto;
    background-color: #007079;
    border-radius: 4px;
    justify-content: center;
    font-size: 14;
    display: flex;
    align-items: center;
    color: white;

    &:hover {
        background-color: rgb(0, 80, 86);
        color: white;
    }
`

export const CardImageWrapper = styled.div`
    width: 401px;
    height: 340px;
    padding: 24px;
    align-self: center;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    @media (max-width: 1024px) {
        padding: 0px;
        width: 0%;
        height: 0%;
    }
`

export const ProjectAndPlantContainer = styled(Card)`
    display: flex;
    flex-direction: column;
    width: 100%;
    max-width: 600px;
    height: 625px;
    padding: 24px;
    gap: 24px;
    flex-wrap: wrap;
    background-color: rgb(255, 255, 255);
    box-sizing: border-box;

    @media (max-width: 1024px) {
        width: calc(100% - 32px);
        height: 100%;
        padding: 16px;
        margin: 0 16px;
    }
`

export const SelectDropDown = styled(Autocomplete)`
    width: 100%;
`

export const SaveAndGoToIIoT = styled(Button)`
    width: 155px;
    height: 48px;
    margin-left: auto;
`

export const HeaderRecentlyAdded = styled(Typography)`
    padding-top: 4px;
    align-self: flex-start;

    @media (max-width: 1024px) {
        padding-top: 0;
        variant: h1;
    }
`

export const SensorCardsContainer = styled(Card)`
    display: flex;
    flex-direction: column;
    align-self: stretch;
    width: 100%;
    gap: 20px;
    background-color: initial;
    box-shadow: none;
    box-sizing: border-box;

    & > * {
        width: 100% !important;
        max-width: 100% !important;
        box-sizing: border-box;
    }
`
